module.exports = __webpack_public_path__ + "static/img/scene10.06c419c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene10.jpg
// module id = T7H/
// module chunks = 1